import React from 'react';
import moment from 'moment';
import cslJson from 'config/task-types/csl.json';
import { counselingTaskTypes } from 'constants/lists';
import { CounselingTaskType } from '../../../constants/enums';
import { CounselingStatus } from '../../../interfaces/enums/TaskStatuses/CounselingStatus';

import { staticProviders, getCommonProviders } from './common-provider';
import EditAdministration from '../../../containers/patient/therapy/edit-therapy-administration';
import { useTypedSelector } from '../../../hooks/use-typed-selector';
import { noteTagTypes } from '../../../constants/lists';
import { getTherapyStatusById, isCslNoteRequired } from '../../../services/utils/therapy-service';

export default (task, state) => {
  const therapy = state.therapies && task.therapy_id ? state.therapies[task.therapy_id] : null;
  const followupDtValue = state.formValues && state.formValues.followup_dt;
  const followupDateChanged =
    followupDtValue &&
    task.followup_dt &&
    moment.utc(followupDtValue).format('YYYY-MM-DD') !==
      moment.utc(task.followup_dt).format('YYYY-MM-DD');
  const CANCELED_STATUSES = [
    CounselingStatus.Canceled,
    CounselingStatus.CanceledByTherapyOptIn,
    CounselingStatus.CanceledDeceased,
    CounselingStatus.OnHold,
  ];
  const noteRequired =
    !CANCELED_STATUSES.includes(state.taskStatusId) &&
    followupDateChanged &&
    isCslNoteRequired(task, followupDtValue, therapy);

  let updatedFields = [];

  const setNoteFieldRequired = valueForRequiredProp => {
    const listOfFields = cslJson.fields.map(item => {
      if (item.id === 'note') {
        item.required = valueForRequiredProp;
        item.defaultPlaceholder = valueForRequiredProp
          ? 'Please document the reason why the counseling reassessment is deferred'
          : null;
      }
      return item;
    });
    updatedFields = updatedFields.concat(listOfFields);
  };

  setNoteFieldRequired(noteRequired);

  return {
    ...staticProviders,
    ...getCommonProviders(task, state, cslJson),
    methodOptions: [
      { id: 1, name: 'In Person' },
      { id: 2, name: 'On the Phone' },
      { id: 3, name: 'Chart Review' },
    ],
    counselingTaskTypeOptions: counselingTaskTypes.filter(
      t => t.id !== CounselingTaskType.Discharge,
    ),
    canceledReasons: [
      { id: 1, name: 'Patient Opt Out' },
      { id: 2, name: 'Other' },
    ],
    noOngoingReasons: [
      { id: 1, name: 'Patient Opt Out' },
      { id: 2, name: 'Therapy Complete' },
    ],
    cslChecklistOptions: state.cslChecklistOptions,
    json: {
      ...cslJson,
      fields: updatedFields.length ? [...updatedFields] : [...cslJson.fields],
    },
  };
};
